import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useBreadcrumbs } from '@/features/header';
import { NewOfferView } from '@/features/offers/components/new-offer-view/new-offer-view';
import { OfferHeaderView } from '@/features/offers/components/new-offer-view/header';
import { Container } from '@/components';
import { useSidebar } from '@/components/ui/sidebar';
import { cn } from '@/utils/styles';
import { useValidateOfferAccess } from '@/features/offers/hooks';

type Mode = 'buyer' | 'seller';

export function Offer({ mode = 'buyer' }: Readonly<{ mode?: Mode }>) {
  const { t } = useTranslation(['offers']);
  const { offerId: id } = useParams();
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';
  const { isLoading, hasAccess } = useValidateOfferAccess(id!, mode);

  useBreadcrumbs(() => [
    { title: mode === 'buyer' ? t('Buyer dashboard') : t('Seller dashboard') },
    { title: t('Expression of Interest') },
  ]);

  if (!id) return null;
  if (isLoading) return null; // O un spinner
  if (!hasAccess) return null; // Ya se redirigió
  return (
    <div className="flex flex-col pb-20 lg:pb-10">
      <div
        className={cn(
          'bg-neutral-10 fixed right-0 left-0 border-b border-neutral-50 py-4',
          'md:right-3',
          isCollapsed ? 'md:left-[60px]' : 'md:left-[220px]',
          'transition-all duration-150 ease-in-out'
        )}
        style={{ zIndex: 7 }}
      >
        <Container size="xl" className="space-y-6 px-4 sm:px-6 md:px-12">
          <OfferHeaderView id={id} />
        </Container>
      </div>

      <Container size="xl" className="w-full px-4 pt-16 sm:px-6 md:px-8 md:pt-24">
        <NewOfferView id={id} mode={mode} />
      </Container>
    </div>
  );
}
